import * as React from 'react';

import styled from '@emotion/styled';

import { COLORS } from '@clutter/clean';

import { StyledCardElement } from './styled_card_element';

const Input = styled.input`
  height: 48px;
  margin-bottom: 24px;
  ::placeholder {
    color: ${COLORS.hippo};
  }
`;

export const Fields: React.FC<{
  name?: string;
  onName(name: string | undefined): void;
}> = ({ name, onName }) => (
  <>
    <Input
      className="form-control"
      placeholder="Name"
      type="text"
      onChange={(event) => onName(event.target.value || undefined)}
      value={name ?? ''}
    />
    <StyledCardElement />
  </>
);
